import React, { Fragment } from 'react'
import { Form, Radio } from 'antd'

import DrawerFiltersLineCollapsable, { DrawerFiltersLineCollapsableItem } from 'components/DrawerFilters/DrawerFiltersLineCollapsable'
import { useAuth } from 'hooks'
import ProposalEgiModel from 'egi/models/ProposalEgiModel'

function AnalisysFilter () {
  const user = useAuth()
  if (ProposalEgiModel.canSeeAnalisys(user.areaName, user.level)) {
    return (
      <div className='proposal-radio-filter'>
        <DrawerFiltersLineCollapsable label='Análise'>
          <Form.Item
            name='reviewAnalysis'
            initialValue={''}
          >
            <Radio.Group>
              <DrawerFiltersLineCollapsableItem key={''}>
                <Radio value={''}>Todos</Radio>
              </DrawerFiltersLineCollapsableItem>

              <DrawerFiltersLineCollapsableItem key='starting'>
                <Radio value='starting'>Iniciando</Radio>
              </DrawerFiltersLineCollapsableItem>

              <DrawerFiltersLineCollapsableItem key='analysis'>
                <Radio value='analysis'>Análise</Radio>
              </DrawerFiltersLineCollapsableItem>
              <DrawerFiltersLineCollapsableItem key={''}>
                <Radio value='review'>Reanálise</Radio>
              </DrawerFiltersLineCollapsableItem>
            </Radio.Group>
          </Form.Item>
        </DrawerFiltersLineCollapsable>
      </div>
    )
  }

  return <Fragment/>
}

export { AnalisysFilter }
